import React, { Component, useContext, useEffect, useState } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IOnUpdateSupplierDTO from "../../../../models/DTO/IOnUpdateSupplierDTO";
import IOnUpdateVendorDTO from "../../../../models/DTO/IOnUpdateVendorDTO";
import IUpdateSupplierDTO from "../../../../models/DTO/IUpdateSupplierDTO";
import IUpdateVendorDTO from "../../../../models/DTO/IUpdateVendorDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import IVendorModel from "../../../../models/IVendorModel";
import AddressBlock from "../../../shared/AddressBlock/AddressBlock";
import OwButton from "../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import { SocketContext } from "../../../../contexts/SocketContext";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";

type Props = {
    profileModel: ISupplierModel | IVendorModel;
    // userModel: IUserUI;
    // notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    cancel: (refreshData?: boolean) => void;
    // socket: Socket;
};

type State = {
    profileModel: ISupplierModel | IVendorModel;
};

export const BusinessProfileSidebar = (props: Props) => {
    const socket = useContext(SocketContext)!;
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [profileModel, setProfileModel] = useState(props.profileModel);

    const onUpdateSupplier = (data: IOnUpdateSupplierDTO) => {
        props.cancel(true);
    };

    const onUpdateVendor = (data: IOnUpdateVendorDTO) => {
        props.cancel(true);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.SupplierOnUpdateSupplier, fn: onUpdateSupplier },
        { endpoint: EndpointsEnum.VendorsOnUpdateVendor, fn: onUpdateVendor },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const saveChanges = () => {
        if (userModel.isSupplierUser) {
            const _supplierModel = profileModel as ISupplierModel;

            _supplierModel.Bill_To = profileModel.Bill_To;
            _supplierModel.Ship_To = profileModel.Ship_To;

            const payload: IUpdateSupplierDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: profileModel.guid,
                supplierModel: _supplierModel,
            };

            socket.emit(EndpointsEnum.SupplierUpdateSupplier, payload);
        } else {
            const _vendorModel = profileModel as IVendorModel;

            // @ts-expect-error
            const payload: IUpdateVendorDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                vendorGuid: _vendorModel.guid,
                billTo: profileModel.Bill_To,
                shipTo: profileModel.Ship_To,
                name: profileModel.name,
                email: profileModel.email || "",
                options: {},
                tokenOptions: {},
            };

            socket.emit(EndpointsEnum.VendorsUpdateVendor, payload);
        }
    };

    const handleChange = (e: any, section?: string) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state = {
            profileModel: {
                ...profileModel,
            },
        };

        if (section) {
            // @ts-expect-error
            state.profileModel[section][name] = value;
        } else {
            // @ts-expect-error
            state.profileModel[name] = value;
        }

        setProfileModel(state.profileModel);
    };

    return (
        <div className="BusinessProfileSidebar p-2 d-flex flex-column h-100" style={{ overflowY: "scroll" }}>
            <div className={"d-flex w-100 justify-content-between"}>
                <OwTitle title={"business_profile"} tag={"h3"} leftIconName={"fad fa-user"} />
                <div>
                    <OwButton
                        className={"btn-danger"}
                        centerIconClass={"fas fa-times"}
                        fn={() => {
                            props.cancel(true);
                        }}
                    />
                </div>
            </div>
            <div>
                <div className={"mt-2 mb-2"}>
                    <OwLabel title={"company_name"} noBottomMargin={true} />
                    <div>
                        <OwInputWrapper fn={handleChange} name={"name"} value={profileModel.name} />
                    </div>
                </div>

                <div className={"mt-2 mb-2"}>
                    <OwLabel title={"email"} noBottomMargin={true} />
                    <div>
                        <OwInputWrapper fn={handleChange} name={"email"} value={profileModel.email} />
                    </div>
                </div>

                <div className={"mt-5 mb-2"}>
                    <OwLabel title={"bill_to"} noBottomMargin={true} />
                    <div>
                        <AddressBlock
                            prefix={""}
                            showName={true}
                            fn={(e: any) => {
                                handleChange(e, "Bill_To");
                            }}
                            address={profileModel.Bill_To}
                            showCompanyName={true}
                            showPhoneFax={true}
                        />
                    </div>
                </div>

                <div className={"mt-5 mb-2"}>
                    <OwLabel title={"ship_to"} noBottomMargin={true} />
                    <div>
                        <AddressBlock
                            prefix={""}
                            showName={true}
                            fn={(e: any) => {
                                handleChange(e, "Ship_To");
                            }}
                            address={profileModel.Ship_To}
                            showCompanyName={true}
                            showPhoneFax={true}
                        />
                    </div>
                </div>

                <div className={"mt-2 mb-2"}>
                    <div>
                        <OwButton title={"save"} fn={saveChanges} />
                    </div>
                </div>
            </div>
        </div>
    );
};
